import { Component } from "react";

import { FormGroup, Input, Label, FormFeedback, Button } from 'reactstrap';

class Btn extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {


        return (
            <FormGroup className="position-relative">
                <Button className={this.props.className} disabled={this.props.loader}  onClick={this.props.onClick}>
                    {this.props.children}
                    {this.props.loader && <span className=" ml-2 mb-1 spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
                </Button>
            </FormGroup>
        )
    }
}

export default Btn;
